import Count       from "../../fundamentals/count/Count";
import Pagination  from "../../fundamentals/pagination/Pagination";
import MailGroup   from "./MailGroup";
import MailGroupId from "./MailGroupId";

class MailGroups {
  constructor(
    private readonly _list: MailGroup[] = [],
    private readonly _pagination: Pagination = new Pagination(),
    private readonly _count: Count = new Count(),
  ) {
  }

  public has(id: MailGroupId): boolean {
    return !!this._list.find((mailGroup: MailGroup) => mailGroup.id.equals(id));
  }

  public add(mailGroup: MailGroup): MailGroups {
    this._list.push(mailGroup);
    return new MailGroups(this._list, this._pagination, this._count);
  }

  public remove(mailGroup: MailGroup): MailGroups {
    const list: MailGroup[] = this._list.filter(value => value.id.notEquals(mailGroup.id));
    return new MailGroups(list, this._pagination, this._count);
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): MailGroup[] {
    return this._list;
  }

  get pagination() {
    return this._pagination;
  }

  get count() {
    return this._count;
  }
}

export default MailGroups;
